<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7_233)">
      <path
        d="M2.5625 9.31378V4.18622C2.5625 2.46103 3.95763 1.0625 5.67863 1.0625H3.78125C2.05534 1.0625 0.65625 2.46159 0.65625 4.1875V9.3125C0.65625 11.0384 2.05534 12.4375 3.78125 12.4375H5.67863C3.95763 12.4375 2.5625 11.039 2.5625 9.31378V9.31378Z"
        :fill="color"
      />
      <path
        d="M12.25 13.0625H3.74934C1.68194 13.0625 0 11.3805 0 9.31316V4.1875C0 2.11975 1.68225 0.4375 3.75 0.4375H12.25C14.3177 0.4375 16 2.11975 16 4.1875V9.3125C16 11.3802 14.3177 13.0625 12.25 13.0625ZM3.75 1.6875C2.3715 1.6875 1.25 2.809 1.25 4.1875V9.31316C1.25 10.6913 2.37122 11.8125 3.74934 11.8125H12.25C13.6285 11.8125 14.75 10.691 14.75 9.3125V4.1875C14.75 2.809 13.6285 1.6875 12.25 1.6875H3.75ZM11.625 14.9375C11.625 14.5923 11.3452 14.3125 11 14.3125H5C4.65481 14.3125 4.375 14.5923 4.375 14.9375C4.375 15.2827 4.65481 15.5625 5 15.5625H11C11.3452 15.5625 11.625 15.2827 11.625 14.9375Z"
        :fill="color"
      />
      <path
        d="M11.625 14.9375C11.625 14.5923 11.3452 14.3125 11 14.3125H5C4.65481 14.3125 4.375 14.5923 4.375 14.9375C4.375 15.2827 4.65481 15.5625 5 15.5625H11C11.3452 15.5625 11.625 15.2827 11.625 14.9375Z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.74934 13.0625H12.25C14.3177 13.0625 16 11.3802 16 9.3125V4.1875C16 2.11975 14.3177 0.4375 12.25 0.4375H3.75C1.68225 0.4375 0 2.11975 0 4.1875V9.31316C0 11.3805 1.68194 13.0625 3.74934 13.0625ZM11 14.3125C11.3452 14.3125 11.625 14.5923 11.625 14.9375C11.625 15.2827 11.3452 15.5625 11 15.5625H5C4.65481 15.5625 4.375 15.2827 4.375 14.9375C4.375 14.5923 4.65481 14.3125 5 14.3125H11ZM10.5928 7.65175L11.0092 7.90156C11.3052 8.07916 11.4011 8.46306 11.2235 8.75906C11.1064 8.95438 10.8993 9.06259 10.687 9.06259C10.5776 9.06259 10.4667 9.03384 10.366 8.97344L9.94198 8.719C9.6021 9.05966 9.17029 9.30816 8.6876 9.42503V9.96875C8.6876 10.3139 8.40779 10.5938 8.0626 10.5938C7.71741 10.5938 7.4376 10.3139 7.4376 9.96875V9.425C6.94391 9.30544 6.50382 9.04778 6.16048 8.69512L5.69666 8.97341C5.59601 9.03381 5.48513 9.06256 5.3757 9.06256C5.16338 9.06256 4.95638 8.95434 4.83916 8.75903C4.66157 8.46306 4.75754 8.07916 5.05354 7.90156L5.52241 7.62025C5.44713 7.3745 5.40635 7.11381 5.40635 6.84375C5.40635 6.57369 5.44713 6.313 5.52241 6.06725L5.05354 5.78594C4.75757 5.60834 4.66157 5.22444 4.8392 4.92844C5.01679 4.63244 5.40076 4.5365 5.69666 4.71406L6.16048 4.99234C6.50382 4.63969 6.94391 4.38203 7.4376 4.26247V3.71875C7.4376 3.37356 7.71741 3.09375 8.0626 3.09375C8.40779 3.09375 8.6876 3.37356 8.6876 3.71875V4.26247C9.17029 4.37934 9.6021 4.62784 9.94201 4.9685L10.366 4.71406C10.6619 4.5365 11.0459 4.63244 11.2235 4.92844C11.4011 5.22444 11.3052 5.60834 11.0092 5.78594L10.5928 6.03575C10.6744 6.29069 10.7189 6.56209 10.7189 6.84375C10.7189 7.12541 10.6744 7.39681 10.5928 7.65175ZM6.65635 6.84375C6.65635 7.61916 7.2872 8.25 8.0626 8.25C8.83801 8.25 9.46885 7.61916 9.46885 6.84375C9.46885 6.06834 8.83801 5.4375 8.0626 5.4375C7.2872 5.4375 6.65635 6.06834 6.65635 6.84375Z"
        :fill="color"
      />
      <path
        d="M8.06226 8.25C7.28685 8.25 6.65601 7.61916 6.65601 6.84375C6.65601 6.06834 7.28685 5.4375 8.06226 5.4375C8.83766 5.4375 9.46851 6.06834 9.46851 6.84375C9.46851 7.61916 8.83766 8.25 8.06226 8.25Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_7_233">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: 'currentColor'
    }
  }
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
</style>
